/**
 * Composes all top-level providers in one place so main.jsx stays tiny and the
 * provider order is explicit and reviewable.
 */
import { Provider as ReduxProvider } from 'react-redux';

import { store } from '@app/store';
import { SessionNotice } from '@components/common/SessionNotice';
import { ToastProvider } from '@components/ui';
import { AppModeProvider } from '@variant/useAppMode';

import { ErrorBoundary } from './ErrorBoundary';

export function AppProviders({ children }) {
  return (
    <ErrorBoundary>
      <ReduxProvider store={store}>
        <AppModeProvider>
          {/* Toasts (useNotify) — one stack for the whole app. SessionNotice
              shows "Session expired" when the session layer ends it. */}
          <ToastProvider>
            <SessionNotice />
            {children}
          </ToastProvider>
        </AppModeProvider>
      </ReduxProvider>
    </ErrorBoundary>
  );
}
